import { render } from "./ResultContent.vue?vue&type=template&id=a1805558&scoped=true"
import script from "./ResultContent.vue?vue&type=script&lang=js"
export * from "./ResultContent.vue?vue&type=script&lang=js"

import "./ResultContent.vue?vue&type=style&index=0&id=a1805558&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1805558"]])

export default __exports__